
    import { Component } from 'vue-property-decorator';
    import ListBase from '@/lib/listbase';
    import PageRequest from '@/store/entities/page-request';
    import District from '@/store/entities/preferences/district';
    import ListView from '@/components/helper/list-view.vue';
    import ModalView from '@/components/helper/modal-view.vue';

    class PageDistrictRequest extends PageRequest { }

    @Component({
        components: { ListView, ModalView }
    })
    export default class Districts extends ListBase {
        pagerequest: PageDistrictRequest = new PageDistrictRequest();
        district: District = new District();
        modalSetting: any = {
            entity: "district",
            title: 'Distrito'
        };

        edit() {
            this.modalShow = !this.modalShow;
        }
        async afterSave() {
            let list: any = this.$refs.listView
            await list.getpage();
        }
        items = [
            this.gItem({ type: 'object', prop: 'department_id', label: 'Departamento', required: true, size: 6 }),
            this.gItem({ type: 'object', prop: 'province_id', label: 'Provincia', required: true, size: 6 }),
            this.gItem({ type: 'text', prop: 'name', label: 'Nombre', required: true, size: 6 }),
            this.gItem({ type: 'text', prop: 'code', label: 'Ubigeo', size: 6 }),
            this.gItem({ type: 'active', size: 6 })
        ]
        columns = [
            this.gCol('province.name', 'Provincia', 'text'),
            this.gCol('name', 'Nombre', 'text'),
            this.gCol('code', 'Ubigeo', 'text'),
            this.gCol('active', 'Habilitado'),
            this.defaultActions('edit')
        ]
        async created() {
            //this.getpage();
        }
    }
